import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { COMPANY_INFO } from '../data';

export default function Header() {
  return (
    <header className="relative z-50 w-full border-b border-brand-grey bg-brand-black">
      {/* Top Bar med info */}
      <div className="border-b border-brand-grey bg-brand-dark py-2 text-xs text-gray-600">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <div className="flex items-center gap-4 text-gray-600">
            <span className="flex items-center gap-1.5 whitespace-nowrap text-gray-700 font-medium">
              <MapPin className="h-3.5 w-3.5 text-brand-yellow" />
              <span>{COMPANY_INFO.address}</span>
            </span>
            <span className="hidden md:inline text-gray-300">|</span>
            <span className="hidden md:inline whitespace-nowrap text-gray-600">CVR: {COMPANY_INFO.cvr}</span>
          </div>
        </div>
      </div>

      {/* Hovednavigation */}
      <div className="mx-auto max-w-7xl px-4 pt-6 pb-5 md:px-6 flex flex-col items-start">
        {/* Logo og Kontakt */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between w-full gap-4">
          <Link to="/" className="flex items-center shrink-0">
            <img
              src={COMPANY_INFO.logoUrl}
              alt={COMPANY_INFO.name}
              className="h-18 w-auto object-contain sm:h-22 md:h-28"
            />
          </Link>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <a
              href={`tel:${COMPANY_INFO.phoneRaw}`}
              className="flex items-center gap-1.5 hover:text-brand-yellow transition-colors duration-200 whitespace-nowrap text-gray-700 font-medium text-sm sm:text-base"
            >
              <Phone className="h-4 w-4 text-brand-yellow" />
              <span>{COMPANY_INFO.phone}</span>
            </a>
            <a
              href={`mailto:${COMPANY_INFO.email}`}
              className="flex items-center gap-1.5 hover:text-brand-yellow transition-colors duration-200 whitespace-nowrap text-gray-700 font-medium text-sm sm:text-base"
            >
              <Mail className="h-4 w-4 text-brand-yellow" />
              <span>{COMPANY_INFO.email}</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
